import { createApprovalMapSdk } from './sdkFactory'
import { EUROPE_COUNTRIES, EUROPE_MAP_VIEWBOX, WORLD_COUNTRIES, WORLD_MAP_VIEWBOX, WORLD_PLACE_BY_ID } from './worldMapPaths'

// Entry -> approval-map-widget.umd.js
//
// Injects the world dataset, which switches on the USA / Global / Europe /
// List View tabs, the arrow nav, and the geo-targeted opening tab. Shipped to
// every embed on 2026-07-29; before that this entry rendered the US map alone
// and the tabs staged behind a second bundle (sdk-next.ts,
// approval-map-widget-next.umd.js), both deleted when the tabs went live.

export type {
  ApprovalMapWidgetConfig,
  ApprovalMapWidgetInstance,
} from './sdkFactory'

export default createApprovalMapSdk({
  global: { viewBox: WORLD_MAP_VIEWBOX, countries: WORLD_COUNTRIES },
  europe: { viewBox: EUROPE_MAP_VIEWBOX, countries: EUROPE_COUNTRIES },
  placeById: WORLD_PLACE_BY_ID,
})
